import React, { Suspense } from 'react';
import { LoadingAnimation, ErrorBoundary } from '@dtna/dvs-core-dcp-ui-libraries';
import { importRemote } from 'module-federation-import-remote';
import { getMfeUrl } from '@dtna/dvs-core-dcp-client-utils/lib/utils/mfe';
import NavbarLoadChecker from '../NavbarLoadChecker';
import { mfeLazyLoadFatalErrorHandler } from '../../utils/mfe';

const Navbar = React.lazy(() => importRemote<any>({
  url: getMfeUrl('NAVBAR'),
  scope: 'Navbar',
  module: 'App',
  bustRemoteEntryCache: false,
}).catch(mfeLazyLoadFatalErrorHandler));

export interface NavbarWrapperProps {
  onLoad: () => void;
}

export default function NavbarWrapper(props: NavbarWrapperProps) {
  const { onLoad } = props;
  return (
    <Suspense fallback={<LoadingAnimation />}>
      <NavbarLoadChecker onLoad={onLoad} />
      <ErrorBoundary>
        <Navbar />
      </ErrorBoundary>
    </Suspense>
  );
}
